'use es6';

import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import CommonMessageHeaderContent from '../common-message-header/CommonMessageHeaderContent';
import { jsx as _jsx } from "react/jsx-runtime";
export default class TypingHeaderContent extends PureComponent {
  render() {
    const {
      isSenderLoading,
      message,
      sender,
      senderName
    } = this.props;
    return /*#__PURE__*/_jsx(CommonMessageHeaderContent, {
      sender: sender,
      senderName: senderName,
      isSenderLoading: isSenderLoading,
      message: message
    });
  }
}
TypingHeaderContent.displayName = 'TypingHeaderContent';
TypingHeaderContent.propTypes = {
  isSenderLoading: PropTypes.bool,
  message: PropTypes.oneOfType([RecordPropType('CommonMessage'), RecordPropType('TypingIndicatorMessage')]).isRequired,
  sender: RecordPropType('Sender'),
  senderName: PropTypes.node
};